const DashboardTitle = [
  "Employee Id",
  "Name",
  "Clock In ",
  "Email",
  "Reporting Manager",
  "Branch",
];

export default DashboardTitle;
